// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GooglePlusCircleFilledSvg from "@fishx/icons-svg/es/asn/GooglePlusCircleFilled";
import FishxIcon from '../components/FishxIcon';

var GooglePlusCircleFilled = function GooglePlusCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: GooglePlusCircleFilledSvg
  }));
};

GooglePlusCircleFilled.displayName = 'GooglePlusCircleFilled';
export default React.forwardRef(GooglePlusCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/GooglePlusCircleFilled.js
// module id = 2891
// module chunks = 0